import React from 'react';
import { Alert } from 'antd';
import styles from './ui.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectNewShutdown } from '../filterNew/model/selectors';
import { setValueNewShutdown } from '../filterNew/model/actions';
import { fetchShutdownsThunk } from '../../shared/model/actions';

const NewShutdownAlert = () => {
  const newShutdown = useSelector(selectNewShutdown);

  const dispatch = useDispatch();

  if (!newShutdown) {
    return null;
  }

  const handleClose = () => {
    dispatch(setValueNewShutdown(null));

    dispatch(fetchShutdownsThunk());
  };

  return (
    <Alert
      className={styles.root}
      onClose={handleClose}
      message={`Отключение создано под номером ${newShutdown}`}
      type="success"
      closable
      showIcon={false}
    />
  );
};

export default NewShutdownAlert;
